// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f02e15fc3686fe8db8db","883":"af1018ed3506d86d9384"}[chunkId] + ".js";
};